<template>
  <div>
    <div :class="['select-by', !isLogged ? 'align-items-center' : '', { disabled: isPlateValid }]">
      <div :class="['know-licenseplate', isLogged ? '' : 'mr-2']">
        <p>Non conosci la targa?</p>
      </div>
      <div :class="['select-dropdown', !isLogged ? 'justify-content-center' : '']">
        <div :class="['select-brand', { active: isDropdownOpen }, !isLogged ? 'm-0' : '']">
          <p id="selectBrandBtn" v-on:click="toggleDropdown">Seleziona marca e modello</p>
        </div>
        <div class="vertical-ruler" v-if="isLogged"></div>
        <div class="select-my-bike" v-if="isLogged" v-on:click="toggleMyBikeDropdown">
          <p>
            Seleziona da le mie moto
            <span>
              <img
                :class="{ 'caret-down': true, rotated: isMyBikeDropdownOpen }"
                src="../../../images/project-img/Arrow-Small-down.png"
                alt="caret down"
                width="16"
            /></span>
          </p>
        </div>
      </div>
    </div>
    <div
      v-if="!isPlateValid"
      id="dropdownContainer"
      :class="[
        isLogged ? 'dropdown-container' : 'dropdown-container-center',
        { hidden: !isDropdownOpen },
      ]"
    >
      <div class="close-dropdown">
        <button type="button" id="closeDropdown" class="close-dropdown" v-on:click="closeDropdown">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14.004"
            height="14"
            viewBox="0 0 14.004 14"
          >
            <path
              id="Icon_ionic-ios-close"
              data-name="Icon ionic-ios-close"
              d="M19.946,18.289l5-5A1.172,1.172,0,0,0,23.29,11.63l-5,5-5-5a1.172,1.172,0,1,0-1.657,1.657l5,5-5,5a1.172,1.172,0,1,0,1.657,1.657l5-5,5,5a1.172,1.172,0,1,0,1.657-1.657Z"
              transform="translate(-11.285 -11.289)"
              fill="#606060"
            />
          </svg>
        </button>
      </div>
      <div class="d-flex justify-content-center align-items-center">
        <div class="input_container radio_container justify-content-evenly w-100 mb-30">
          <label class="input-radio">
            <span>Moto</span>
            <input
              type="radio"
              v-model.number="kind_bike"
              name="kind_bike"
              :value="1"
              @change="onRadioClick(1)"
            />
            <span class="checkmark"></span>
          </label>
          <label class="input-radio">
            <span>Scooter</span>
            <input
              type="radio"
              v-model.number="kind_bike"
              name="kind_bike"
              :value="2"
              @change="onRadioClick(2)"
            />
            <span class="checkmark"></span>
          </label>
        </div>
      </div>
      <form action="/allestimenti" method="POST" @submit="handleSubmit" ref="findBike">
        <input type="hidden" name="_token" :value="csrfToken" />
        <input type="text" hidden value="storica" name="quotation_type" />
        <input type="number" hidden :value="vehicle_type" name="vehicle_type" />
        <div v-if="kind_bike === 1" class="find-bike-container">
          <div class="form-group">
            <custom-select
              v-model="params.marca"
              :options="formattedOptions(options.marca)"
              :placeholder="placeholders.marca"
              :disabled="!options.marca || !Object.keys(options.marca).length"
              @change="handleSelectChange('marca')"
              :name="'choice[marca]'"
              :isOpen="openDropdown === 0"
              @toggle="handleToggle(0)"
            ></custom-select>

            <custom-select
              v-model="params.modello"
              :options="formattedOptions(options.modello)"
              :placeholder="placeholders.modello"
              :disabled="!options.modello || !Object.keys(options.modello).length"
              @change="handleSelectChange('modello')"
              :name="'choice[modello]'"
              :isOpen="openDropdown === 6"
              @toggle="handleToggle(6)"
            ></custom-select>
          </div>
          <div class="form-group">
            <custom-select
              v-model="params.anno_im"
              :options="formattedOptions(options.anno_im)"
              :placeholder="placeholders.anno_im"
              :disabled="!options.anno_im || !Object.keys(options.anno_im).length"
              @change="handleSelectChange('anno_im')"
              :name="'choice[anno_im]'"
              :isOpen="openDropdown === 2"
              @toggle="handleToggle(2)"
            ></custom-select>

            <custom-select
              v-model="params.cilindrata"
              :options="formattedOptions(options.cilindrata)"
              :placeholder="placeholders.cilindrata"
              :disabled="!options.cilindrata || !Object.keys(options.cilindrata).length"
              @change="handleSelectChange('cilindrata')"
              :name="'choice[cilindrata]'"
              :isOpen="openDropdown === 7"
              @toggle="handleToggle(7)"
            ></custom-select>
          </div>
        </div>
        <div v-else class="find-bike-container">
          <div class="form-group">
            <custom-select
              v-model="params.marca"
              :options="formattedOptions(options.marca)"
              :placeholder="placeholders.marca"
              :disabled="!options.marca || !Object.keys(options.marca).length"
              @change="handleSelectChange('marca')"
              :name="'choice[marca]'"
              :isOpen="openDropdown === 0"
              @toggle="handleToggle(0)"
            ></custom-select>

            <custom-select
              v-model="params.modello"
              :options="formattedOptions(options.modello)"
              :placeholder="placeholders.modello"
              :disabled="!options.modello || !Object.keys(options.modello).length"
              @change="handleSelectChange('modello')"
              :name="'choice[modello]'"
              :isOpen="openDropdown === 6"
              @toggle="handleToggle(6)"
            ></custom-select>
          </div>
          <div class="form-group">
            <custom-select
              v-model="params.anno_im"
              :options="formattedOptions(options.anno_im)"
              :placeholder="placeholders.anno_im"
              :disabled="!options.anno_im || !Object.keys(options.anno_im).length"
              @change="handleSelectChange('anno_im')"
              :name="'choice[anno_im]'"
              :isOpen="openDropdown === 2"
              @toggle="handleToggle(2)"
            ></custom-select>

            <custom-select
              v-model="params.cilindrata"
              :options="formattedOptions(options.cilindrata)"
              :placeholder="placeholders.cilindrata"
              :disabled="!options.cilindrata || !Object.keys(options.cilindrata).length"
              @change="handleSelectChange('cilindrata')"
              :name="'choice[cilindrata]'"
              :isOpen="openDropdown === 7"
              @toggle="handleToggle(7)"
            ></custom-select>
          </div>
        </div>
        <div class="send-find-bike my-35">
          <button
            class="find-bike"
            type="submit"
            :class="{ disabled: !isFormComplete }"
            :disabled="!isFormComplete || loading"
            title="Trova veicolo"
          >
            <template v-if="!loading">Trova Moto</template>
            <loader v-else size="20px" />
          </button>
        </div>
      </form>
    </div>
    <div
      id="myBikeDropdownContainer"
      class="my-bike-dropdown-container"
      :class="{ hidden: !isMyBikeDropdownOpen }"
    >
      <div class="close-dropdown">
        <button
          type="button"
          id="closeMyBikeDropdown"
          class="close-dropdown"
          v-on:click="closeMyBikeDropdown"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14.004"
            height="14"
            viewBox="0 0 14.004 14"
          >
            <path
              id="Icon_ionic-ios-close"
              data-name="Icon ionic-ios-close"
              d="M19.946,18.289l5-5A1.172,1.172,0,0,0,23.29,11.63l-5,5-5-5a1.172,1.172,0,1,0-1.657,1.657l5,5-5,5a1.172,1.172,0,1,0,1.657,1.657l5-5,5,5a1.172,1.172,0,1,0,1.657-1.657Z"
              transform="translate(-11.285 -11.289)"
              fill="#606060"
            />
          </svg>
        </button>
      </div>
      <div v-if="isLogged && myBike && Object.keys(myBike).length">
        <form action="/api/mybike-selection" method="POST" class="my-bike-single">
          <input type="hidden" name="quotation_type" :value="quotation_type" />
          <input type="hidden" name="vehicle_type" :value="vehicle_type" />
          <button type="submit" class="my-bike-button">
            <img :src="myBike.img ? myBike.img : '/images/project-img/placeholder.png'" :alt="myBike.nome" width="50" />
            <span class="text-bold">{{ myBike.nome }}</span>
          </button>
        </form>
      </div>
      <p v-else-if="isLogged">Non hai moto salvate.</p>
    </div>
  </div>
</template>

<script>
import Loader from './Loader.vue';
import CustomSelect from './CustomSelect.vue';
import axios from 'axios';
export default {
  name: 'SelectStoricDropdown',
  components: {
    Loader,
    CustomSelect,
  },
  props: {
    vehicle_type: {
      type: Number,
      required: true,
    },
    quotation_type: {
      type: String,
      required: true,
    },
    isLogged: {
      type: Boolean,
      required: false,
    },
    myBike: {
      type: Object,
      required: true,
    },
    isPlateValid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      kind_bike: 1,
      isDropdownOpen: false,
      isMyBikeDropdownOpen: false,
      loading: false,
      csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      selectOrder: ['marca', 'modello', 'anno_im', 'cilindrata'],
      options: {
        marca: {},
        anno_im: {},
        modello: {},
        cilindrata: {},
      },
      params: {
        marca: '',
        anno_im: '',
        modello: '',
        cilindrata: '',
      },
      placeholders: {
        marca: 'Marca*',
        anno_im: 'Anno prima immatricolazione*',
        modello: 'Modello*',
        cilindrata: 'Cilindrata*',
      },
      openDropdown: null,
    };
  },
  computed: {
    isFormComplete() {
      return (
        this.params.marca && this.params.anno_im && this.params.modello && this.params.cilindrata
      );
    },
  },
  methods: {
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    closeDropdown() {
      this.isDropdownOpen = false;
    },
    toggleMyBikeDropdown() {
      if (this.isDropdownOpen) {
        this.isDropdownOpen = false;
      }
      this.isMyBikeDropdownOpen = !this.isMyBikeDropdownOpen;
    },
    closeMyBikeDropdown() {
      this.isMyBikeDropdownOpen = false;
    },
    formattedOptions(options) {
      if (!options || !Object.keys(options).length) {
        return [];
      }
      return Object.keys(options).map(key => ({
        value: key,
        text: options[key],
      }));
    },
    getDefaultPlaceholder(field) {
      const defaultPlaceholders = {
        marca: 'Marca*',
        anno_im: 'Anno prima immatricolazione*',
        modello: 'Modello*',
        cilindrata: 'Cilindrata*',
      };
      return defaultPlaceholders[field] || '';
    },
    onRadioClick(value) {
      this.kind_bike = value;
      this.resetAllParams();
      this.fetchChoices();
      this.$emit('radio-clicked', value);
    },
    async fetchChoices() {
      const requestData = {
        ...this.params,
        vehicle_type: this.kind_bike,
        quotation_type: this.quotation_type,
      };
      try {
        const response = await axios.post('/api/choices', requestData);
        this.options = response.data;
        await this.autoSelectOptions();
      } catch (error) {
        console.error('Error fetching choices:', error);
      }
    },
    handleSelectChange(changedField) {
      this.resetSubsequentSelects(changedField);
      this.autoSelectOptions();
    },
    async handleSubmit(event) {
      event.preventDefault();
      this.loading = true;
      console.log('→ loading =', this.loading);
      try {
        this.$refs.findBike.submit();
      } catch (error) {
        window.alert(
          'Stiamo rilevando un problema nel collegamento con i servizi del Ministero dei Trasporti e di ACI per il recupero delle informazioni sulle targhe. Ti consigliamo di scegliere il veicolo da quotare utilizzando le tendine di Marca-Modello-Allestimento ed anno di immatricolazione. Ci scusiamo per il temporaneo disservizio.',
        );
      }
      this.loading = false;
    },
    handleCarSelection(id) {
      try {
        this.$refs.findMyCar.submit();
      } catch (error) {
        window.alert(
          'Stiamo rilevando un problema nel collegamento con i servizi del Ministero dei Trasporti e di ACI per il recupero delle informazioni sulle targhe. Ti consigliamo di scegliere il veicolo da quotare utilizzando le tendine di Marca-Modello-Allestimento ed anno di immatricolazione. Ci scusiamo per il temporaneo disservizio.',
        );
      }
    },
    handleToggle(index) {
      if (this.openDropdown === index) {
        this.openDropdown = null;
      } else {
        this.openDropdown = index;
      }
    },
    resetSubsequentSelects(changedField) {
      const index = this.selectOrder.indexOf(changedField);

      if (index !== -1) {
        // Ottieni i campi successivi
        const subsequentFields = this.selectOrder.slice(index + 1);

        // Resetta i parametri e le opzioni delle select successive
        subsequentFields.forEach(field => {
          this.params[field] = '';
          this.options[field] = {};
          this.placeholders[field] = this.getDefaultPlaceholder(field);
        });
      }
    },
    async autoSelectOptions(paramsChanged = false, loopCounter = 0, maxLoops = 10) {
      if (loopCounter >= maxLoops) {
        console.warn('Raggiunto il numero massimo di iterazioni per la selezione automatica');
        return;
      }
      const requestData = {
        ...this.params,
        vehicle_type: this.kind_bike,
        quotation_type: this.quotation_type,
      };

      try {
        const response = await axios.post('/api/choices', requestData);
        this.options = response.data;
        paramsChanged = false;

        let nextFieldToSelect = null;
        for (const field of this.selectOrder) {
          if (!this.params[field]) {
            nextFieldToSelect = field;
            break;
          }
        }

        for (const field in this.options) {
          if (!this.params[field]) {
            const fieldOptions = this.options[field];
            const optionsArray = this.formattedOptions(fieldOptions);

            if (optionsArray.length === 1) {
              this.params[field] = optionsArray[0].value;
              paramsChanged = true;
            } else {
              // Se questo campo è il prossimo da selezionare
              if (field === nextFieldToSelect) {
                if (optionsArray.length === 0) {
                  // Nessuna opzione disponibile, aggiorna il placeholder
                  this.placeholders[field] = 'Non ci sono modelli disponibili';
                } else {
                  // Ripristina il placeholder originale se ci sono opzioni disponibili
                  this.placeholders[field] = this.getDefaultPlaceholder(field);
                }
              }
            }
          }
        }

        if (paramsChanged) {
          await this.autoSelectOptions(true, loopCounter + 1, maxLoops);
        }
      } catch (error) {
        console.error('Error fetching choices:', error);
      }
    },
    resetAllParams() {
      // svuota tutti i parametri e le opzioni
      Object.keys(this.params).forEach(field => (this.params[field] = ''));
      Object.keys(this.options).forEach(field => (this.options[field] = {}));
      // reset placeholder
      Object.keys(this.placeholders).forEach(f => {
        this.placeholders[f] = this.getDefaultPlaceholder(f);
      });
    },
  },
  mounted() {
    this.autoSelectOptions();
  },
};
</script>
<style scoped>
select.selected {
  color: black;
}

.m-0 {
  margin: 0;
}

.mr-2 {
  margin-right: 0.5rem;
}

.my-35 {
  margin: 35px 0;
}

.disabled {
  pointer-events: none;
  opacity: 0.3;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/SelectStoricDropdown.vue